class Version {
    getVersion() {
        return "3.0.2";
    }
}

export default new Version();